var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5335 11.8333H0.466797V10.9H13.5335V11.8333Z",
    fill: "#282825"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.53376 9.30671V0.166676H7.46709V9.30671L11.8038 4.97003L12.4637 5.62999L7.33041 10.7633C7.14816 10.9456 6.85269 10.9456 6.67044 10.7633L1.53711 5.62999L2.19708 4.97003L6.53376 9.30671Z",
    fill: "#282825"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIc);
export default __webpack_public_path__ + "static/media/upload_ic.a324f6adcfdf8aa0d0a243192e2fc601.svg";
export { ForwardRef as ReactComponent };